export default (to, from, next) => {
    if(JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole == "BRAND_MANAGER" || JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole == "BRAND_ADMIN"){
        next()
    }else{
        alert("브랜드 관리자 권한이 없습니다.");
        document.getElementsByTagName('body')[0].click();
        next('/' + to.params.sitename +'/booking/booking-request');
    }
}